module.exports = __webpack_public_path__ + "img/75600.a8df87b1.jpg";